module.exports = __webpack_public_path__ + "media/icons/quality_over_quantity-48d62df2.svg";